// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Qa3LP","colMin":"styles_colMin__4uW5e","colCheckbox":"styles_colCheckbox__P_qKV"};